import { useState } from "react";
import { Button, Card, List, Modal, Space } from "antd";
import { useIssueKinds } from "context/providers/issue_kinds";
import Item from "./components/Item";
import CreateIssueKindModal from "components/create_modals/CreateIssueKindModal";
import { useAuth } from "context/providers/auth";

const IssueKinds = ({
  create_issue_kind_ref,
  first_issue_kind_ref,
  setOpenEditTour,
}) => {
  const { data, refetch } = useIssueKinds();
  const {
    state: {
      user: { company },
    },
  } = useAuth();
  const [is_open_preview_modal, setOpenPreviewModal] = useState();
  return (
    <Card
      title={`Rodzaje zgłoszeń ${data?.length > 0 ? `(${data.length})` : ""}`}
      styles={{ body: { padding: "0 24px" } }}
      style={{ marginBottom: 24 }}
      extra={
        <Space>
          <Button
            disabled={!data.length}
            type="primary"
            htmlType="button"
            onClick={() => setOpenPreviewModal(true)}
          >
            Podgląd
          </Button>
          <CreateIssueKindModal
            create_issue_kind_ref={create_issue_kind_ref}
            setOpenEditTour={setOpenEditTour}
          />
        </Space>
      }
    >
      {is_open_preview_modal && (
        <Modal
          title="Podgląd widoku zgłoszeń"
          centered
          width="100%"
          open={true}
          onOk={() => setOpenPreviewModal(false)}
          onCancel={() => setOpenPreviewModal(false)}
        >
          <iframe
            style={{ width: "100%", height: "80vh" }}
            title="Podgląd widoku zgłoszeń"
            src={`https://evertask.pl/${company.slug}/zgloszenia`}
            frameborder="0"
          />
        </Modal>
      )}
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item, index) => (
          <Item
            {...item}
            first_issue_kind_ref={first_issue_kind_ref}
            refetch={refetch}
            is_first={index === 0}
            is_last={index === data?.length - 1}
          />
        )}
      />
    </Card>
  );
};

export default IssueKinds;
